<mat-expansion-panel [expanded]="shouldExpand$ | async">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ 'LIB_ORDERS.FULFILLMENT_STATUS.TITLE' | translate }}</mat-panel-title>
  </mat-expansion-panel-header>
  @if (rows$ | async; as rows) {
    <div>
      @for (row of rows; track row; let index = $index) {
        <div>
          <orders-fulfillment-row
            [name]="row.name"
            [iconUrl]="row.iconUrl"
            [type]="row.type"
            [parentName]="row.parentName"
            [activationStatus]="row.activationStatus"
            [activationErrorDetails]="row.failureDetails"
            [fulfillmentStatus]="row.fulfillmentStatus"
            [menuItems]="row.menuItems"
            [persona]="persona"
            (menuItemClicked)="menuItemClick($event)"
            (workOrdersLinkClicked)="handleWorkOrdersLinkClicked()"
          />
        </div>
        @if (index < rows.length - 1) {
          <mat-divider></mat-divider>
        }
      }
    </div>
  }
</mat-expansion-panel>
